export enum ProjectSettingsCreateOrEditMode {
  Create = 'create',
  Edit = 'edit'
}
